<template>
    <div v-if="!error" class="columns mx-0 py-6-tablet">
        <div class="page column is-10 is-offset-1" data-aos="zoom-in">
            <div class="post py-6">
                <div v-if="loading" class="loading">
                    Loading...
                </div>
                <div v-if="post" class="content pt-6">
                    <div class="columns">
                        <div class="column is-6">
                            <h3 v-cloak class="subtitle is-3">Découvrez le journal du mois</h3>
                            <p><b-tag type="is-primary" rounded>{{ post.title | capitalize }}</b-tag></p>
                            <p v-html="post.excerpt"></p>
                            <div class="has-text-centered">
                                <router-link class="button is-warning is-medium is-rounded my-3" :to="'/post/'+ post._id">Voir plus</router-link>
                            </div>
                        </div>
                        <div class="column is-6">
                            <template v-if="post.illustration">
                                <figure class="image">
                                    <img :src="post.illustration.path" alt="illustration">
                                </figure>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios');

export default {
    data: function() {
        return {
            maintitle: 'Dernier n° | ',
            loading: true,
            post: null,
            error: null,
            curr_path: window.location.origin,
        }
    },
    components: {
        //SocialSharing
    },
    name: 'Post',
    props: {
        msg: String
    },
    created() {
        this.fetchData()
    },
    updated() {
        this.maintitle = this.maintitle + this.post.title
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.error = this.post = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_posts
            axios({
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        filter: { categorie: 'parution' },
                        //fields: {fieldA:1},
                        limit: 1,
                        sort: { datepost: -1 },
                        populate: 1, // resolve linked collection items
                        lang: 'fr' // return normalized language fields (fieldA_de => fieldA)
                    })
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.post = response.data.entries[0]
                        vm.error = null
                    } else {
                        vm.post = null
                        vm.error = 'page introuvable'
                    }
                })
                .catch(function() {
                    vm.error = 'page introuvable'
                })

        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 500px;
}

.post .image {
    max-width: 350px;
    padding-left: auto;
    padding-right: auto;
    margin-left: auto;
    margin-right: auto;
}
</style>